
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor4On as ObiResistor4OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-4-on.js';
 
 
 

 
 export const ObiResistor4On = createComponent({
   react: React,
   tagName: 'obi-resistor-4-on',
   elementClass: ObiResistor4OnElement,
   events: {
     
   }
  });
 
 